// extracted by mini-css-extract-plugin
module.exports = {"synopsis":"-R-O-0","atfSynopsis":"_1npiSz","btfSynopsis":"_3memqS","atfSynopsisRedesign":"_18F2lI"};